import { PropertyKind } from "shared/types";
import { ApartmentsComVariant } from "types/landlord/address";

// Apartments.com requires every feed listing to declare a property kind. Derive
// it from the property kind the same way the unit-detail screen does, defaulting
// to single_family when the kind is unknown.
export const apartmentsVariantForKind = (
  kind: PropertyKind | null | undefined
): ApartmentsComVariant =>
  kind === PropertyKind.MultiFamily ? "multi_family" : "single_family";
